<div class="manage-users white-content-page">
    <upsc-page-header [pageTitle]="'ManageUsers'|translate">
        <div page-actions>
            <button type="button" mat-raised-button (click)="addUser()" class="page-action">
                {{'AddUser'|translate}}
            </button>
        </div>
    </upsc-page-header>

    <div class="table-wrapper" [class.responsive-table]="dtOptions.responsive">
        <table datatable
               [dtOptions]="dtOptions"
               [dtTrigger]="dtTrigger"
               class="stripe"
               [hidden]="!users">
            <thead>
            <tr>
                <th class="all trigger-column"></th>
                <th>
                    {{'UserID'|translate}}
                </th>
                <th>
                    {{'Name'|translate}}
                </th>
                <th>
                    {{'Email'|translate}}
                </th>
                <th>
                    {{'DefaultLocation'|translate}}
                </th>
                <th>
                    {{'Role'|translate}}
                </th>
                <th class="all">
                </th>
            </tr>
            </thead>
            <tbody class="text-nowrap grid-rows">
            <tr *ngFor="let user of users">
                <td class="trigger-cell"></td>
                <td>
                    {{ user.UserName }}
                </td>
                <td>
                    {{user.FirstName}} {{user.LastName}}
                </td>
                <td>
                    {{user.Email}}
                </td>
                <td>
                    <!--[ppi] - 11 street way {{user.DefaultLocation}}-->
                    {{ getDefaultLocation(user.DefaultLocation) }}
                </td>
                <td>
                    <span *ngIf="user.IsAdmin"> <strong>{{'Admin'|translate}}</strong> </span>
                    <span *ngIf="user.IsGuest"> {{'Guest'|translate}} </span>
                    <span *ngIf="!user.IsGuest && !user.IsAdmin"> {{'User'|translate}} </span>
                </td>
                <td>
                    <div class="actions">
                        <button type="button"
                                mat-raised-button
                                (click)="editUser(user.UserId)"
                                color="primary">
                            {{'Edit'|translate}}
                        </button>
                        <button type="button"
                                mat-raised-button
                                (click)="confirmRemove(user.UserId)"
                                *ngIf="user.UserName!=user.CustomerId && currentUserId != user.UserId"
                                class="alternative-button">
                            {{'Remove'|translate}}
                        </button>
                    </div>
                    <!--<a href="#manageUser" role="button" data-toggle="modal" data-dismiss="modal" class="btn btn-sm btn-sky white-font"
                    (click)="editUser(user.UserId)" > {{'Edit'|translate}} </a>
                    <a href="#confirmRemove" #confirmRemove role="button" data-toggle="modal" data-dismiss="modal" class="btn btn-sm btn-stone black-font"
                    *ngIf="user.UserName!=user.CustomerId && currentUserId != user.UserId" (click)="userIdToRemove=user.UserId" > {{'Remove'|translate}}</a>-->
                </td>
            </tr>
            <!--<tr *ngIf="noRecordsFound">
                  <td colspan="7" class="text-center">
                    <span style="color:red;font-size:12px;"> {{'NoRecordsFound'|translate}} </span>
                  </td>
                </tr>-->
            </tbody>
        </table>
    </div>
</div>
